import { NgModule } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UcrFormsModule } from '../forms/ucrforms.module';
import { SharedModule } from '../shared/shared.module';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { HeaderMenuComponent } from './header-menu/header-menu.component';
import { UcrSecurityService } from './ucr-security/ucr-security.service';
import { SwitchUserComponent } from './switch-user/switch-user.component';
import { AppHttpInterceptor } from './app-http/app-http-interceptor';

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forRoot([], {relativeLinkResolution: 'legacy'}),
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        BrowserAnimationsModule,
        HttpClientModule,
        UcrFormsModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule
    ],
    declarations: [BreadcrumbsComponent, FooterComponent, HeaderComponent, HeaderMenuComponent, SwitchUserComponent],
    exports: [BreadcrumbsComponent, FooterComponent, HeaderComponent, HeaderMenuComponent],
    providers: [
        UcrSecurityService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AppHttpInterceptor,
            multi: true
        },
        Location
    ]
})
export class CoreModule {}